import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ScanPointTimeScanRequest } from "../shared/ScanPointTimeScanRequest";

@Component({
	selector: "caass-time-scan-manual-bar",
	templateUrl: "./time-scan-manual-bar.component.html",
	styleUrls: ["./time-scan-manual-bar.component.css"],
})
export class TimeScanManualBarComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() FacilityID: any;
	@Input() FacilityLocationID: any;
	@Input() TimeScanTypeID: any;
	@Input() TimeScanTypeDesc: any;
	@Input() Receipt_IDPrinterID: any;
	@Output() CloseManual: EventEmitter<any> = new EventEmitter();
	@Output() ManualScan: EventEmitter<ScanPointTimeScanRequest> = new EventEmitter();

	Mode: string = "Selector"; //Selector | Alert | Attendance | IDHistory | Schedule
	ErrorMessage: any;

	SelectedPerson: any = null;

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	//
	// Top Options
	//
	onSelector() {
		this.ErrorMessage = "";

		this.Mode = "Selector";
		this.SelectedPerson = null;
	}
	onAlert() {
		this.ErrorMessage = "";

		this.Mode = "Alert";
	}
	onAttendance() {
		this.ErrorMessage = "";

		this.Mode = "Attendance";
	}
	onIDHistory() {
		this.ErrorMessage = "";

		this.Mode = "IDHistory";
	}
	onSchedule() {
		this.ErrorMessage = "";

		this.Mode = "Schedule";
	}

	//
	// Bottom Bar
	//
	onHallPass() {
		this.ErrorMessage = "";

		this.Mode = "HallPass";
	}

	onMarkTime() {
		this.ErrorMessage = "";

		if (this.SelectedPerson == null) {
			this.ErrorMessage = "Select a Person to Manually Scan them in";
		} else {
			this.Mode = "MarkTime";
		}
	}

	onClose() {
		this.CloseManual.emit(true);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////

	onPersonSelected(val) {
		this.SelectedPerson = val;
	}

	onManualScan(val) {
		this.ManualScan.emit(val);
	}

	onCancelMarkTime() {
		this.onAlert();
	}
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////

	PersonSelected() {
		return this.SelectedPerson != null;
	}

	/////////////////////////////////////////////////////////////////
}
